/**
 * Maps an array of data items to a template.
 * @param {Element[]} results
 * @param {jQuery} $itemTemplate
 * @return {Element[]}
 */
const mapDataToTemplate = (results, $itemTemplate) => (
    results
        .map(element => ({ ...element.dataset }))
        .map(entry => {
            const $item = $itemTemplate.clone();
            $item.find('[data-title]').text(entry.title);
            $item.find('[data-filename]').text(entry.filename);
            $item.find('[data-filetype]').text(entry.filetype);
            $item.find('[data-filesize]').text(entry.filesize);
            $item.find('[data-url]').attr('href', entry.url);
            $item.find('[data-downloadtype]').text(entry.downloadtype);

            return $item.get(0);
        })
);

export default mapDataToTemplate;



// WEBPACK FOOTER //
// ./src/scripts/components/downloads-list/mapDataToTemplate.js